

export class GuidService {

  public static ShiftGuid(originalGuid: string): string {
    let result = '';

    for (let i = 0; i < originalGuid.length; i++) {
      var c = originalGuid[i];
      if (c === '-') {
        result += '-';
      } else {
        var num = 0;

        if (c === '0') num = 0
        else if (c === '1') num = 1;
        else if (c === '2') num = 2;
        else if (c === '3') num = 3;
        else if (c === '4') num = 4;
        else if (c === '5') num = 5;
        else if (c === '6') num = 6;
        else if (c === '7') num = 7;
        else if (c === '8') num = 8;
        else if (c === '9') num = 9;
        else if (c === 'a' || c === 'A') num = 10;
        else if (c === 'b' || c === 'B') num = 11;
        else if (c === 'c' || c === 'C') num = 12;
        else if (c === 'd' || c === 'D') num = 13;
        else if (c === 'e' || c === 'E') num = 14;
        else if (c === 'f' || c === 'F') num = 15;

        num = 15 - num;

        if (num === 0) result += '0';
        else if (num === 1) result += '1';
        else if (num === 2) result += '2';
        else if (num === 3) result += '3';
        else if (num === 4) result += '4';
        else if (num === 5) result += '5';
        else if (num === 6) result += '6';
        else if (num === 7) result += '7';
        else if (num === 8) result += '8';
        else if (num === 9) result += '9';
        else if (num === 10) result += 'a';
        else if (num === 11) result += 'b';
        else if (num === 12) result += 'c';
        else if (num === 13) result += 'd';
        else if (num === 14) result += 'e';
        else if (num === 15) result += 'f';
      }
    }

    return result;
  }

}
